export enum PaymentType
{
    CreditCardVisa = 1,
    MasterCard = 2,
    Discover = 3,
    ECheckAch = 4,
    AmericanExpress = 5,
    Affirm = 7,
}